export class SaleOrderNoRequest{
    saleOrderNo:string;
}